import { FC, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { AuthContext } from "src/context/authContext";

import { redirectPath } from "src/constants";
import { HeaderElement, HeaderElementType } from "src/types";



const MainNav: FC<{ headerLink: HeaderElement }> = ({ headerLink }): JSX.Element => {
  const navigate = useNavigate()
  const { userData } = useContext(AuthContext)
  const closeMobileMenu = () => {
    ['authHeader', 'hubHeader'].forEach(id => {
      const navbarCollapse = document.getElementById(id);
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        navbarCollapse.classList.remove('show');
      }
    });
  };

  return (
    <li
      className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
      data-tour={headerLink.title === "Submit a Request" ? "fifth-step" : ""}
    >
      {headerLink.actionType === HeaderElementType.ROUTE ? (
        <NavLink
          className={({isActive}) => {
            return ["nav-link", isActive ? "" : ""].join(" ")
          }}
          aria-current="page"
          to={headerLink.title === '' ? (userData ? redirectPath(userData) : "") : headerLink.redirectLink}
          end
          onClick={closeMobileMenu}
        >
          {headerLink.title}
        </NavLink>
      ) : null}
      {headerLink.actionType === HeaderElementType.BUTTON ? (
        <button
          className="btn btn-primary rounded-pill"
          onClick={() => {
            closeMobileMenu();
            navigate(headerLink.redirectLink)
          }}
        >
          {headerLink.title}
        </button>
      ) : null}
      {headerLink.actionType === HeaderElementType.LINK ? (
        <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
          {headerLink.title}
        </a>
      ) : null}
      {headerLink.actionType === HeaderElementType.DRPODOWN ? (
        <>
          <a
            className="nav-link dropdown-toggle"
            href="." data-bs-toggle="dropdown" aria-expanded="false"
          >
            {headerLink.title}
          </a>
          <ul className="resources-dropdown dropdown-menu dropdown-center">
            {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
              <li key={index}>
                <a
                  className="dropdown-item" href={header.redirectLink} target="_blank"
                  rel="noreferrer"
                  onClick={closeMobileMenu}
                >
                  {header.title}
                </a>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </li>
  )
}

export default MainNav
